<template>
	<DialogFormDialog ref="dialog" :strings="strings" @reset="reset">
		<v-text-field
			v-model="values.name"
			:rules="nameRules"
			:label="strings.nameLabel"
			:placeholder="placeholder"
			type="text"
		/>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

const data = () => ({
	strings: strings.live.scenes.renameSceneDialog,

	values: { name: null },
	nameRules: [v => !!_.trim(v).length || "Name is required"],
});

export default {
	props: {
		placeholder: { type: String, required: false, default: null },
	},

	data,

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	mounted() {
		// Wrap parent pop method to capture *current* value as a placeholder.
		this.pop = (...args) => {
			this.values.name = this.placeholder;
			return this.$refs.dialog.pop(...args);
		};
	},

	methods: {
		reset() {
			Object.assign(this, data());
		},
	},
};
</script>
